/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ balance: NonNullable<unknown>, calls: NonNullable<unknown>, name: NonNullable<unknown>, action: NonNullable<unknown>, each: NonNullable<unknown> }} Seo_Endpoint_A_Free_CallsInputs */

const en_seo_endpoint_a_free_calls = /** @type {(inputs: Seo_Endpoint_A_Free_CallsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Yes. A new AnyAPI account starts with ${i?.balance} of free balance and no card required, which covers ${i?.calls} ${i?.name} ${i?.action} calls at ${i?.each} each.`)
};

const zh_hans1_seo_endpoint_a_free_calls = /** @type {(inputs: Seo_Endpoint_A_Free_CallsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`可以。新的 AnyAPI 账户自带 ${i?.balance} 免费余额，无需绑卡，足够调用 ${i?.calls} 次 ${i?.name} ${i?.action}，每次 ${i?.each}。`)
};

const pt_br2_seo_endpoint_a_free_calls = /** @type {(inputs: Seo_Endpoint_A_Free_CallsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sim. Uma conta nova da AnyAPI começa com ${i?.balance} de saldo grátis, sem cartão, o que cobre ${i?.calls} chamadas de ${i?.action} do ${i?.name} a ${i?.each} cada.`)
};

const es_seo_endpoint_a_free_calls = /** @type {(inputs: Seo_Endpoint_A_Free_CallsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sí. Una cuenta nueva de AnyAPI empieza con ${i?.balance} de saldo gratis, sin tarjeta, que alcanza para ${i?.calls} llamadas a ${i?.action} de ${i?.name} a ${i?.each} cada una.`)
};

const fr_seo_endpoint_a_free_calls = /** @type {(inputs: Seo_Endpoint_A_Free_CallsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Oui. Un nouveau compte AnyAPI démarre avec ${i?.balance} de solde gratuit, sans carte, ce qui couvre ${i?.calls} appels ${i?.name} ${i?.action} à ${i?.each} chacun.`)
};

const de_seo_endpoint_a_free_calls = /** @type {(inputs: Seo_Endpoint_A_Free_CallsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ja. Ein neues AnyAPI-Konto startet mit ${i?.balance} Gratis-Guthaben, ohne Karte. Das deckt ${i?.calls} ${i?.name}-${i?.action}-Aufrufe zu je ${i?.each}.`)
};

const ru_seo_endpoint_a_free_calls = /** @type {(inputs: Seo_Endpoint_A_Free_CallsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Да. Новый аккаунт AnyAPI стартует с бесплатным балансом ${i?.balance}, карта не нужна. Этого хватает на ${i?.calls} вызовов ${i?.name} ${i?.action} по ${i?.each} за каждый.`)
};

const it_seo_endpoint_a_free_calls = /** @type {(inputs: Seo_Endpoint_A_Free_CallsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sì. Un nuovo account AnyAPI parte con ${i?.balance} di saldo gratuito e senza bisogno di carta, che copre ${i?.calls} chiamate ${i?.name} ${i?.action} a ${i?.each} ciascuna.`)
};

/**
* | output |
* | --- |
* | "Yes. A new AnyAPI account starts with {balance} of free balance and no card required, which covers {calls} {name} {action} calls at {each} each." |
*
* @param {Seo_Endpoint_A_Free_CallsInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_endpoint_a_free_calls = /** @type {((inputs: Seo_Endpoint_A_Free_CallsInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Endpoint_A_Free_CallsInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_endpoint_a_free_calls(inputs)
	if (locale === "pt-BR") return pt_br2_seo_endpoint_a_free_calls(inputs)
	if (locale === "es") return es_seo_endpoint_a_free_calls(inputs)
	if (locale === "fr") return fr_seo_endpoint_a_free_calls(inputs)
	if (locale === "de") return de_seo_endpoint_a_free_calls(inputs)
	if (locale === "ru") return ru_seo_endpoint_a_free_calls(inputs)
	if (locale === "it") return it_seo_endpoint_a_free_calls(inputs)
	return en_seo_endpoint_a_free_calls(inputs)
});